(ns common.schema.entities.workspace.kyc.templates.innovestor.legal-entity-cofund-angel-entity
  (:require
   [common.schema.entities.workspace.kyc.questions.info-texts :as info-texts]
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]
   [common.schema.entities.workspace.kyc.templates.innovestor.company-config :as company-config]
   [common.schema.entities.workspace.kyc.templates.capman.board-member :as board-member]
   [common.schema.entities.workspace.kyc.templates.capman.pep :as pep]
   [common.schema.entities.workspace.kyc.templates.capman.ubo :as ubo]))

(def schema
  {:kyc-template/template-name
   "Co-Investment Fund Angel - Legal Entity"

   :kyc-template/kyc-form-preface
   company-config/form-preface-text

   :kyc-template/svg-logo
   company-config/svg-logo

   :kyc-template/png-logo
   company-config/png-logo

   :kyc-template/help-email-address
   company-config/contact-email

   :kyc-template/kyc-form-title
   {:translations {:en "Know Your Customer (KYC) form"
                   :fi "Asiakastietokysely"}}

   :kyc.legal-entity/basic-information
   {:ord
    1.0
    :translations
    {:en "Basic information"
     :fi "Perustiedot"}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/name]
      [:kyc-legal-entity/sole-shareholder]
      [:kyc-legal-entity/jurisdiction]
      [:kyc-legal-entity/business-id]
      [:kyc-legal-entity/trade-register-extract-mandatory]
      [:kyc-legal-entity/legal-form]
      [:kyc-legal-entity/legal-form-other]
      [:kyc-legal-entity/tax-country]
      [:kyc-legal-entity/confirm-marketing-consent]])}

   :kyc.legal-entity/address-information
   {:ord
    2.0
    :translations
    {:en "Address"
     :fi "Osoite"}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/address]
      [:kyc-legal-entity/zip-code]
      [:kyc-legal-entity/city]
      [:kyc-legal-entity/country]
      [:kyc-legal-entity/main-business-address]])}

   :kyc.legal-entity/financial-information
   {:ord
    3.0
    :translations
    {:en "Financial information"
     :fi "Pääoma"}
    :info
    info-texts/financials-info-innovestor
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/source-of-wealth]])}

   :kyc-legal-entity/board-member-data
   {:ord
    4.0
    :translations
    {:en "Board members"
     :fi "Hallituksen jäsenet"}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/board-members-edn {:data/template board-member/schema}]])
    :full-width-section? true}

   :kyc-legal-entity/ubo-data
   {:ord
    5.0
    :translations
    {:en "Ultimate beneficial owners (UBO)"
     :fi "Yhteisön tosiasialliset edunsaajat"}

    :info
    {:fi
     (str
      "<p>Tosiasialliset edunsaajat, jotka käyttävät määräysvaltaa yhtiössä.</p>"
      "<p><strong>Huomaathan, että jokaisessa yhtiössä on tosiasiallinen edunsaaja.</strong></p>"
      "<p>Luonnollisen henkilön katsotaan käyttävän määräysvaltaa yhteisössä, jos hänellä suoraan tai epäsuorasti on:"
      "<ol><li><strong>25% tai suurempi omistusosuus yhteisön osakkeista tai äänivallasta perustuen nomistukseen, "
      "jäsenyyteen, yhtiöjärjestykseen/sääntöihin, yhtiösopimukseen tai muuhun sopimukseen tai sääntöihin.</strong></li>"
      "<li><strong>oikeus nimittää tai erottaa enemmistö yhteisön hallituksen tai muun vastaavan toimielimen jäsenistä "
      "ja, että tällainen oikeus perustuu kohdassa 1. määriteltyihin perusteisiin.</strong></li></ol></p>"
      "<p>Mikäli yhteisön oikeudellinen muoto on yhdistys, uskonnollinen yhteisö tai muu yhteisö, jolla ei ole "
      "edellä määriteltyjä tosiasiallisia edunsaajia, katsotaan hallituksen jäsenten, "
      "(jotka ovat merkittynä yhdistysrekisteriin tai vastaavaan) olevan tosiasiallisia edunsaajia.</p>"
      "<p>Mikäli yhteisö on säätiö (säätiölaki 487/2015), katsotaan hallituksen sekä hallintoneuvoston jäsenten, "
      "(jotka ovat merkittynä säätiörekisteriin tai vastaavaan) olevan tosiasiallisia edunsaajia.</p>"
      "<p><strong>Mikäli yhteisössä ei ole kohdissa 1. ja 2. määriteltyjä henkilöitä, katsotaan toimitusjohtajan ja/tai "
      "hallituksen jäsenten olevan yhteisön tosiasiallisia edunsaajia ellei yhteisö toisin ilmoita.</strong></p>")
     :en
     (str
      "<p>Ultimate Beneficial Owners ('UBOs') who exercise control over an entity.</p>"
      "<p>Please note that every entity has an UBO. A natural person is considered to have control over an entity, "
      "when he/she either directly or indirectly has:"
      "<ol><li><strong>25% or more of shares or voting rights based on ownership, membership, articles of "
      "association, partnership agreement or corresponding rules or other agreement;</strong></li>"
      "<li><strong>The right to nominate or dismiss the majority of the board members or members of another "
      "corresponding organ of the entity, and such right is based on the same grounds as under subsection (1) "
      "above.</strong></li></ol></p>"
      "<p>In case the entity is an association (an association defined in Associations Act 503/1989) or a "
      "religious community or a similar entity which does not have UBOs defined above, the members of the "
      "Board of Directors (members that are registered in the association register or similar) are considered "
      "UBOs.</p>"
      "<p>If the entity is a foundation (Foundations Act, 487/2015), the members of the Board of Directors and "
      "the members of the Supervisory Board (members that are registered in the foundation register or similar) "
      "are considered UBOs.</p>"
      "<p>If the entity is a foreign trust: settlors, trustees, protectors, beneficiaries, classes of "
      "beneficiaries and any other natural persons exercising ultimate effective control over the trust "
      "are considered UBOs.</p>"
      "<p><strong>If an entity does not have persons referred to in subsections (1) or (2) above, the CEO and the "
      "members of the Board of Directors are considered UBOs, unless the entity notifies otherwise.<strong></p>")}
    :conditional-block
    (fn [answers _kyc-process]
      (not= :yes (:kyc-legal-entity/listed-in-stock-exchange? answers)))
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/ubo-edn {:data/template ubo/schema}]])}

   :kyc-legal-entity/PEP-data
   {:ord
    6.0
    :translations
    {:en "Politically exposed person (PEP)"
     :fi "Poliittinen vaikutusvalta (PEP)"}
    :info
    {:en
     (str
      "<p>This list automatically contains all UBO's who are marked as PEP. If the investor has other "
      "politically exposed persons, add them here</p>"
      "<p>Confirm for instance following positions:"
      "<ul><li>Member of the board</li>"
      "<li>Chief executive officer</li>"
      "<li>Representative (for example the signatories of this form)</li></ul></p>"
      "<p>A person is considered a PEP, who is in a prominent public function or an immediate family "
      "member or a close associate of such a person either in Finland or another country?</p>")

     :fi
     (str
      "<p>Lisää tähän poliittisesti vaikutusvaltaiset henkilöt joita et ole jo kirjannut edelliselle "
      "UBO listalle.</p>"
      "<p>Muista esimerkiksi henkilöt seuraavissa positioissa:"
      "<ul><li>Hallituksen jäsen</li>"
      "<li>Toimitusjohtaja</li>"
      "<li>Henkilöt, joilla on nimenkirjoitusoikeus (esimerkiksi tämän lomakkeen allekirjoittaja)</li></ul></p>"
      "<p>Henkilö on poliittisesti vaikutusvaltainen, jos hän tai hänen lähipiiriinsä kuuluva henkilö "
      "toimii tai on toiminut merkittävässä julkisessa virassa Suomessa tai toisessa valtiossa.</p>")}
    :more-info
    {:link-text    {:en "More information"
                    :fi "Lisätietoa täällä"}
     :info-header  {:en "Politically exposed person (PEP)"
                    :fi "Poliittinen vaikutusvalta (PEP)"}
     :info-content
     {:en
      (str
       "<p>Politically Exposed Person <strong>(“PEP”)</strong> refers to a person who is or "
       "during <strong>the last 12 months</strong> "
       "has been in a prominent public function, a close associate or an immediate family member "
       "of such a person either in Finland or another country:</p>"
       "<p><strong>A prominent public function is acting as:</strong>"
       "<ul><li>Head of State, Head of Government, minister, deputy or assistant minister</li>"
       "<li>Member of Parliament</li>"
       "<li>member of supreme court, member of constitutional court or member of some "
       "corresponding judicial body whose decisions are not generally subject to further appeal</li>"
       "<li>member of court of auditors or of the highest decision-making body of an "
       "authority auditing the management of Government funds and corresponding to the "
       "State Audit Office</li>"
       "<li>member of the Board of a central bank</li>"
       "<li>ambassador or chargé d’affaires</li>"
       "<li>high-ranking officer (minimum rank of general) in the armed forces</li>"
       "<li>member of the administrative, management or supervisory body of a "
       "state-owned company</li>"
       "<li>Member of the EU Parliament</li>"
       "<li>commissioner</li>"
       "<li>Member of the EU Court of Justice</li>"
       "<li>Member of the EU Court of Auditors</li></ul></p>"
       "<p><strong>The associates of politically exposed persons are:</strong>"
       "<ul><li>Any natural person who is known to have joint beneficial ownership of a "
       "corporation, entrepreneur or legal arrangement, or any other close business relations, "
       "with a politically exposed person</li>"
       "<li>Any natural person who has sole beneficial ownership of a corporation, "
       "entrepreneur or legal arrangement which is known to have been set up for the benefit "
       "of a politically exposed person</li></ul></p>"
       "<p><strong>The immediate family members of politically exposed persons are:</strong>"
       "<ul><li>The spouse or any partner considered equivalent to a spouse by national law;</li>"
       "<li>The children and their spouses or partners referred to above; and</li>"
       "<li>The parents.</li></ul></p>")
      :fi
      (str
       "Poliittisesti vaikutusvaltainen henkilö <strong>(“PEP”)</strong> toimii tai on toiminut "
       "merkittävässä julkisessa virassa, kuuluu tai on kuulunut sellaisen henkilön lähipiiriin "
       "tai on tai on ollut sellaisen henkilön perheenjäsen tai lähipiiriin kuuluva, Suomessa "
       "tai toisessa valtiossa <strong>viimeisen 12 kuukauden aikana</strong>:</p>"
       "<p><strong>Merkittävänä poliittisena virkana pidetään seuraavia virkoja:</strong>"
       "<ul><li>Valtion- tai hallituksen päämies, ministeri, vara-tai apulaisministeri</li>"
       "<li>Parlamentin jäsen</li>"
       "<li>Korkeimman oikeuden, perustuslakituomioistuimen tai muun vastaavan oikeuselimen jäsen</li>"
       "<li>Keskuspankin johtokunnan jäsen</li>"
       "<li>Suurlähettiläs</li>"
       "<li>Puolustusvoimien kenraalikuntaan kuuluva upseeri</li>"
       "<li>Valtionyritysten hallinto-, johto- ja valvontaelimen jäsen</li>"
       "<li>EU-parlamentin jäsen</li>"
       "<li>Komission jäsen</li>"
       "<li>EU-tuomioistuimen jäsen</li>"
       "<li>EU:n tilintarkastustuomioistuimen jäsen</li></ul></p>"
       "<p><strong>Poliittisesti vaikutusvaltaisen henkilön lähipiiriin kuuluvaksi katsotaan:</strong>"
       "<ul><li>Luonnollinen henkilö, joka toimii poliittisesti vaikutusvaltaisen henkilön "
       "yhtiökumppanina</li>"
       "<li>Luonnollinen henkilö, jonka omistaman yhtiön tosiasiallisena edunsaajana on "
       "poliittisesti vaikutusvaltainen henkilö.</li></ul></p>"
       "<p><strong>Poliittisesti vaikutusvaltaisen henkilön lähipiiriin kuuluvaksi katsotaan:</strong>"
       "<ul><li>Poliittisesti vaikutusvaltaisen henkilön puoliso tai puolisoon kansallisen "
       "lain mukaisesti rinnastettava kumppani</li>"
       "<li>Poliittisesti vaikutusvaltaisen henkilön lapset sekä heidän puolisonsa tai puolisoon "
       "kansallisen lain mukaisesti rinnastettava kumppani.</li>"
       "<li>Poliittisesti vaikutusvaltaisen henkilön vanhemmat</li></ul></p>")}}

    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/has-peps?]
      [:kyc-legal-entity/pep-edn {:data/template pep/schema}]])}

   :kyc-legal-entity/confirmation
   {:ord
    7.0
    :translations
    {:en "Confirm entered data is correct"
     :fi "Syötettyjen tietojen vahvistaminen"}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/confirmation-place]
      [:kyc-legal-entity/confirmation-date]
      [:kyc-legal-entity/confirmation-name]])}

   :kyc-legal-entity/identifications
   {:ord
    13.0

    :translations
    {:en "Entity representative identification"
     :fi "Yhteisön edustajan tunnistetiedot"}

    :keep-together?
    true

    :info
    {:en ""
     :fi ""}

    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/signer-name-1]
      [:kyc-legal-entity/signer-email-1]
      [:kyc-legal-entity/signer-phone-1]
      [:kyc-legal-entity/signer-ssn-1]
      [:kyc-legal-entity/type-of-identification-attachment-1]
      [:kyc-legal-entity/identification-attachment-not-certified-1]])}

   :kyc-legal-entity/signature-info
   {:ord
    8.0
    :translations
    {:en ""
     :fi ""}

    :end-of-pdf?
    true

    :page-break-before?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/signature-info-1
       {:translations
        {:en (str
              "On behalf of the investor, I hereby confirm that the information I have declared "
              "in this form and in its appendices are true and correct. "
              "I undertake to inform Innovestor (backoffice@innovestor.fi) within 30 days in case of any "
              "changes to the declared information.")
         :fi (str "Vakuutan, että tässä lomakkeessa ja sen liitteissä olevat tiedot ovat oikeita, "
                  "ja että sijoittaja sitoutuu ilmoittamaan näiden tietojen muutoksista "
                  "Innovestorille (backoffice@innovestor.fi) 30 päivän kuluessa muutoksesta.")}}]
      [:kyc-legal-entity/signature-info-2
       {:translations
        {:en (str "By signing the Client Information Form I understand that the collected personal "
                  "data may be shared and disclosed within the Innovestor Group  to customer service, "
                  "other customer relationship management, risk management and marketing purposes. "
                  "Innovestor has a right to disclose  personal data to external service providers, "
                  "local tax and financial supervisory authorities in tax reporting "
                  "and supervisory purposes.")
         :fi (str "Allekirjoittamalla tämän lomakkeen ymmärrän, että kerättyä henkilötietoa "
                  "voidaan siirtää ja luovuttaa Innovestor-konsernin sisällä asiakaspalveluun "
                  "ja muuhun asiakassuhteen hoitamiseen, riskienhallintaan ja markkinointiin. "
                  "Innovestorilla voi myös olla oikeus luovuttaa tietoja ulkopuolisille "
                  "palveluntarjoajille sekä Verohallinnolle että Finanssivalvonnalle "
                  "valvonta- ja veroraportointitarkoituksiin.")}}]])}

   :kyc-legal-entity/signature
   {:ord
    9.0

    :translations
    {:en "Signature"
     :fi "Allekirjoitus"}

    :end-of-pdf?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :section-not-read-only
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/signature-date]
      [:kyc-legal-entity/signature-name]
      [:kyc-legal-entity/signature-signature]])}})
